export default {
  1: {
    description:
      'Les organismes publics doivent veiller à ce que les données d’apprentissage ou les autres données d’entrée utilisées par les systèmes d’IA soient légalement collectées, utilisées et divulguées, en tenant compte des droits et des obligations applicables en matière de protection de la vie privée.',
    title: 'Respect des personnes et de la règle de droit',
  },
  2: {
    description:
      'L’utilisation responsable de systèmes d’IA doit viser à répondre aux besoins de la population à l’égard des services publics, tout en faisant la promotion de la diversité et de l’inclusion. Les membres du personnel des organismes publics doivent pouvoir bénéficier de l’accompagnement nécessaire par la mise en place de mécanismes et d’outils.',
    title: 'Inclusion et équité',
  },
  3: {
    description:
      'Des mesures doivent être prises pour vérifier la fiabilité et la robustesse des systèmes d’IA utilisés ou à être utilisés. La qualité des données est un élément clé pour viser la fiabilité et la robustesse d’un système IA, notamment les données doivent être exactes et exemptes de biais pouvant comporter des risques, causer des préjudices ou renforcer diverses formes de discrimination.',
    title: 'Fiabilité et robustesse',
  },
  4: {
    description:
      'L’utilisation responsable de systèmes d’IA doit se faire dans le respect des obligations relatives à la sécurité de l’information. Des mesures de sécurité doivent être mises en place afin de limiter les risques encourus et de protéger adéquatement l’information concernée.',
    title: 'Sécurité',
  },
  5: {
    description:
      'L’utilisation responsable de systèmes d’IA doit permettre d’offrir aux citoyens et aux entreprises des services publics simplifiés, intégrés et de qualité. L’utilisation de tels systèmes doit également viser une gestion optimale des ressources informationnelles et des services publics.',
    title: 'Efficience, efficacité et pertinence',
  },
  6: {
    description:
      'L’utilisation responsable de systèmes d’IA doit s’inscrire dans la recherche d’un développement durable.',
    title: 'Durabilité',
  },
  7: {
    description:
      'L’utilisation responsable de systèmes d’IA doit se faire dans le respect du principe de transparence. Les organismes publics informent clairement les citoyens et les entreprises de la nature et de la portée de tels systèmes ainsi que du moment de leur utilisation de manière à promouvoir la confiance du public dans ceux-ci.',
    title: 'Transparence',
  },
  8: {
    description:
      'L’utilisation responsable de systèmes d’IA implique de fournir aux citoyens et aux entreprises une explication claire et sans ambiguïté des décisions, prédictions ou actions les concernant. Cette explication doit leur permettre de comprendre les interactions et ses conséquences au regard d’une décision ou d’un résultat.',
    title: 'Explicabilité',
  },
  9: {
    description:
      'L’utilisation de systèmes d’IA amène une responsabilité, notamment quant à leur bon fonctionnement. Elle implique de mettre en place des mesures de contrôle et une gouvernance adéquate, incluant la supervision ou la validation humaine.',
    title: 'Responsabilité',
  },
  10: {
    description:
      'Les employés des organismes publics doivent être sensibilisés à l’utilisation, aux bonnes pratiques et aux enjeux pouvant survenir tout au long du cycle de vie des systèmes d’IA dans le cadre de l’exercice de leurs fonctions. Il est important aussi de favoriser le développement de leurs compétences numériques.',
    title: 'Compétence',
  },
}
